import "../../styles/planner.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../Layout";
import Modal from "../Modal";
import { getVoyages, updateVoyage } from "../../data/voyage";
import { showModal } from "../../data/modal";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Archive as ArchiveIcon,
  Unarchive as UnarchiveIcon,
} from "@mui/icons-material";

const VoyageList: React.FC = () => {
  const dispatch = useDispatch();
  const voyagesSlice = useSelector((state: any) => state.voyages);
  const loading = voyagesSlice?.loading ?? false;
  const error = voyagesSlice?.error ?? "";
  const voyages = voyagesSlice?.data ?? [];
  const totalPages = voyagesSlice?.totalPages ?? 2;

  const [toArchive, setToArchive] = useState<any>(null);
  const [statusFilter, setStatusFilter] = useState<'active' | 'archived'>('active');
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(getVoyages(statusFilter));
  }, [dispatch, statusFilter, page]);

  const handleConfirmArchive = async () => {
    if (!toArchive) return;

    await dispatch(updateVoyage({ ...toArchive, status: 'archived' }));

    setToArchive(null);

    dispatch(getVoyages(statusFilter, page));
  };

  const handleUnarchive = async (v: any) => {
    await dispatch(updateVoyage({ ...v, status: 'active' }));
    dispatch(getVoyages(statusFilter, page));
  };

  return (
    <Layout>
      <Modal />
      <Dialog open={Boolean(toArchive)} onClose={() => setToArchive(null)}>
        <DialogTitle>Archive Voyage?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to archive voyage “{toArchive?.name}”?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setToArchive(null)}>Cancel</Button>
          <Button color="error" onClick={handleConfirmArchive}>
            Archive
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container justifyContent="center" sx={{ p: 2 }}>
        <Grid container xs={12} md={12} justifyContent="space-between" mb={1}>
          <FormControl size="small" sx={{ width: 130 }}>
            <InputLabel id="status-filter-label">Status</InputLabel>
            <Select
              labelId="status-filter-label"
              value={statusFilter}
              label="Status"
              onChange={(e) => {
                setStatusFilter(e.target.value as any);
                setPage(1);
              }}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="archived">Archived</MenuItem>
            </Select>
          </FormControl>

          <Button
            size="small"
            variant="contained"
            onClick={() =>
              dispatch(
                showModal({
                  title: `Voyage creation`,
                  description: "Add voyage",
                  form: "voyageform",
                })
              )
            }
          >
            <AddIcon fontSize="small" />
            &nbsp;Voyage
          </Button>
        </Grid>
        <Grid item xs={12} md={12} height="80vh" component={Paper}>
          {loading && (
            <Box textAlign="center" my={4}>
              <CircularProgress />
            </Box>
          )}

          {!loading && !error && voyages.length === 0 && (
            <Typography align="center">No voyages found.</Typography>
          )}

          {!loading && voyages.length > 0 && (
            <TableContainer sx={{ height: '80vh', overflow: 'auto' }}>
              <Table aria-label="voyage table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {voyages.map((v: any) => (
                    <TableRow key={v['@id']}>
                      <TableCell>{v.name || '—'}</TableCell>
                      <TableCell>{v.status || '—'}</TableCell>
                      <TableCell>
                        {v.startDate
                          ? new Date(v.startDate).toLocaleDateString()
                          : '—'}
                      </TableCell>
                      <TableCell>
                        {v.endDate
                          ? new Date(v.endDate).toLocaleDateString()
                          : '—'}
                      </TableCell>
                      <TableCell align="right">
                        {v.status !== 'archived' ? (
                          <>
                            <IconButton
                              onClick={() =>
                                dispatch(
                                  showModal({
                                    title: `Voyage update`,
                                    description: 'Edit voyage',
                                    form: 'voyageform',
                                    formProps: { voyage: v },
                                  })
                                )
                              }
                              size="small"
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              onClick={() => setToArchive(v)}
                              title="Archive voyage"
                              size="small"
                            >
                              <ArchiveIcon fontSize="small" />
                            </IconButton>
                          </>
                        ) : (
                          <IconButton
                            onClick={() => handleUnarchive(v)}
                            title="Unarchive voyage"
                            size="small"
                          >
                            <UnarchiveIcon fontSize="small" />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* {statusFilter === 'archived'  && totalPages > 1 && (
            <Box display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_, value) => setPage(value)}
              />
            </Box>
          )} */}

          {error && !loading && (
            <Typography color="error" align="center">
              {error}
            </Typography>
          )}
        </Grid>
        </Grid>
    </Layout>
  );
};

export default VoyageList;